export const FETCH_TUTORS = 'FETCH_TUTORS';
export const FETCH_TUTORS_SUCCESS = 'FETCH_TUTORS_SUCCESS';
export const FETCH_TUTORS_FAILURE = 'FETCH_TUTORS_FAILURE';
export const FETCH_TUTORS_FILTER_OPTIONS = 'FETCH_TUTORS_FILTER_OPTIONS';
export const FETCH_TUTORS_FILTER_OPTIONS_SUCCESS =
  'FETCH_TUTORS_FILTER_OPTIONS_SUCCESS';
export const FETCH_TUTORS_FILTER_OPTIONS_FAILURE =
  'FETCH_TUTORS_FILTER_OPTIONS_FAILURE';

const TUTORS_INIT_STATE = {
  filterOptions: undefined,
  currentPage: 1,
  totalPages: 1,
  filterType: null,
  tutors: [],
  isLoading: true,
};

export const fetchTutorList = payload => ({
  type: FETCH_TUTORS,
  payload,
});

export const fetchTutorListSuccess = payload => ({
  type: FETCH_TUTORS_SUCCESS,
  payload,
});

export const fetchTutorListFailure = payload => ({
  type: FETCH_TUTORS_FAILURE,
  payload,
});

export const fetchTutorListFilterOptions = () => ({
  type: FETCH_TUTORS_FILTER_OPTIONS,
});

export const fetchTutorListFilterOptionsSuccess = payload => ({
  type: FETCH_TUTORS_FILTER_OPTIONS_SUCCESS,
  payload,
});

export const fetchTutorListFilterOptionsFailure = payload => ({
  type: FETCH_TUTORS_FILTER_OPTIONS_FAILURE,
  payload,
});

const reducer = (state = TUTORS_INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_TUTORS:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_TUTORS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case FETCH_TUTORS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case FETCH_TUTORS_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        filterOptions: action.payload,
      };

    case FETCH_TUTORS_FILTER_OPTIONS_FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export const getTutorList = state => state.tutorList;

export default reducer;



// WEBPACK FOOTER //
// ./app/redux/tutorList.js